<template
  ><div>
    <v-btn class="mb-4" small color="success" @click="openDialog()"
      ><v-icon dark left>mdi-cloud-upload</v-icon> Upload files</v-btn
    >
    <v-dialog persistent v-model="dialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pb-2 pl-0 pt-0"
          >Upload Files</v-card-title
        >

        <v-btn
          :disabeld="loading"
          small
          outline
          color="success"
          :loading="loading"
          @click="pickFile()"
          >{{ !URL ? "Upload" : "re-Upload" }}</v-btn
        >

        <div v-show="!URL" class="dropArea" ref="dropArea">
          Drag and drop a file here
        </div>

        <input
          type="file"
          style="display: none"
          ref="files"
          accept=".pdf, image/*"
          @change="onFilePicked($event)"
        />

        <div style="height: 600px; overflow-y: auto;" class="mt-3" v-if="URL">
          <pdf
            style="max-height: 500px !important; width: 100%;"
            :src="URL"
            v-if="isPdf(URL)"
          ></pdf>
          <img
            style="max-height: 500px !important; width: 100%;"
            v-if="!isPdf(URL)"
            :src="URL"
          />
        </div>
        <div v-if="URL">
          <v-text-field label="Name" v-model="name"> </v-text-field>
          <v-text-field label="Description" v-model="description">
          </v-text-field>
        </div>
        <v-card-actions class="mr-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="reset()">Cancel</v-btn>
          <v-btn :loading="loading" color="success" @click="saveFiles()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    loading: false,
    name: "",
    type: "",
    URL: "",
    updating: false,
    description: "",
  }),

mounted() {
    const dropArea = this.$refs.dropArea;
    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
      dropArea.addEventListener(eventName, this.preventDefaults, false);
    });
    ["dragenter", "dragover"].forEach((eventName) => {
      dropArea.addEventListener(eventName, this.highlight, false);
    });
    ["dragleave", "drop"].forEach((eventName) => {
      dropArea.addEventListener(eventName, this.unhighlight, false);
    });
    ["click"].forEach((eventName) => {
      dropArea.addEventListener(eventName, this.pickFile, false);
    });
    dropArea.addEventListener("drop", this.handleDrop, false);
  },
  
  methods: {
    pickFile() {
      this.$refs.files.click();
    },
    async onFilePicked(e) {
      this.loading = true;
      const files = e.target.files;

      if (!files) return;

      try {
        var formData = new FormData();

        this.files = files;
        formData.append("upload_file", this.files[0]);

        const response = await this.$http.post(
          "api/adminPortal/UploadFile?",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const fileName = this.files[0].name;
        const lastDotIndex = fileName.lastIndexOf(".");
        this.name =
          lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;

        this.type = this.files[0].type;
        this.URL = response.url;
        this.dialog = true;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    async onFilePicked(e) {
      this.loading = true;
      const files = e.target.files;

      if (!files) return;

      try {
        var formData = new FormData();

        this.files = files;
        formData.append("upload_file", this.files[0]);

        const response = await this.$http.post(
          "api/adminPortal/UploadFile?",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const fileName = this.files[0].name;
        const lastDotIndex = fileName.lastIndexOf(".");
        this.name =
          lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;

        this.type = this.files[0].type;
        this.URL = response.url;
        this.dialog = true;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },

    async saveFiles() {
      if (!this.URL) return;
      this.loading = true;
      try {
        await this.$http.post("api/dedicationitems/UpdateAttachments", {
          DedicationItemID: this.item.dedicationItemID,
          Add: [
            {
              FileName: this.name,
              FileType: this.type,
              FileURL: this.URL,
              User: this.$store.state.authentication.user.toLowerCase(),
              FileDescription: this.description,
            },
          ],
        });
      } catch (error) {
      } finally {
        this.loading = false;
        this.resetUpload();
        await this.loadItem();
      }
    },

    reset() {
      this.dialog = false;
      this.loading = false;
      this.name = "";
      this.type = "";
      this.URL = "";
      this.updating = false;
    },

    isPdf(url) {
      return url.toLowerCase().includes("pdf");
    },
    handleDrop(e) {
      this.preventDefaults(e);
      const files = e.dataTransfer.files;
      if (files.length === 0 || this.URL) return;

      const fakeEvent = { target: { files } };
      this.onFilePicked(fakeEvent);
    },
    handleDrop(e) {
      this.preventDefaults(e);
      const files = e.dataTransfer.files;
      if (files.length === 0 || this.URL) return;

      const fakeEvent = { target: { files } };
      this.onFilePicked(fakeEvent);
    },

    highlight(e) {
      e.preventDefault();
      e.target.classList.add("highlight");
    },

    unhighlight(e) {
      e.target.classList.remove("highlight");
    },

    preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    openDialog() {
      this.dialog = true;
    },
  },
};
</script>
<style scoped>
.dropArea {
  border: 2px dashed #ccc;
  width: 100%;
  height: 150px;
  text-align: center;
  padding: 20px;
  cursor: pointer;
}
.highlight {
  border-color: #fc0;
}
</style>
